var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-seller-registered-info" }, [
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("国")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.countryName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("インボイス登録番号（JCT番号）")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.getInvoiceRegistrationNumber(_vm.seller)))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("法人・個人")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.corporateKbnStr))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("統一社会信用番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.unifiedSocialCreditIdentifier))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]法人名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("[法人]法人名フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyNameEiji))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]代表者名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyRepresentativeName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("[法人]代表者名フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyRepresentativeNameEiji))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]郵便番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyZipCode))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]地域")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyStateName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]住所")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyAddress))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]建物名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyAddressBuilding))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]代表電話番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyTellNo))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[法人]自社ホームページURL")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyHpUrl))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]所属部署名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.seller.dept))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]担当者氏名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.sellerName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("[担当]担当者氏名フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.sellerNameEiji))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]郵便番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.seller.zipCode))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]地域")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.stateName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]住所")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.seller.address))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]建物名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.addressBuilding))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]電話番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.seller.telNo))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2498d815", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2498d815","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/userRegisteredInfo/ChinaCorporation.vue
// module id = null
// module chunks = 